// extracted by mini-css-extract-plugin
module.exports = {"rootAd":"styles_rootAd__3Bqtm","rootAdBox":"styles_rootAdBox__X1gdo","adText":"styles_adText__sdUOT","adLink":"styles_adLink__JGYST","adCloseIcon":"styles_adCloseIcon__a2TRf"};